import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';
import { Personnel } from 'model/modal-cms/personnel';
import { AdminService } from '../../../services/admin';
declare var moment: any;
declare var mdtoast: any;
var success_message = mdtoast("Opération effectué avec succès.", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Vous n\'avez pas accès à cette donnée.', { duration: 5000, init: true, type: mdtoast.ERROR });
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-rappert-activiter-med',
  templateUrl: './rappert-activiter-med.component.html',
  styleUrls: ['./rappert-activiter-med.component.scss']
})
export class RappertActiviterMedComponent implements OnInit {
  id: any;
  personnel: Personnel = new Personnel(null);
  fonction: any = "Medecin";
  personnel_med: any;
  id_agent_actuel: any;
  loginuserCMSActuel: any;
  mode_ajout: any;
  @ViewChild('popupProcedure') popupProcedure: Popup;

  constructor(public activatedRoute: ActivatedRoute, private router: Router, public adminService: AdminService, public cmsService: CMSService) {
    this.loginuserCMSActuel = this.adminService.getLoginUseCMS();
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
    this.id = activatedRoute.snapshot.params['id'];


    if (this.loginuserCMSActuel == "com_daf") {
      this.mode_ajout = 1;
    } else {
      this.mode_ajout = 11;
    }

  }


  ngOnInit() {
    this.getListeMed();
    // this.getListMedecin();
  }

  chercherRapport(rp) {
    this.cmsService.getAutreParIM(rp)
      .subscribe(data => {
        this.personnel_med = data
      },
        err => {
          console.log(err);
        })
  }

  getListeMed() {
    this.cmsService.getMed(this.fonction)
      .subscribe(data => {
        this.personnel_med = data
      },
        err => {
          console.log(err);
        })

  }


  getListMedecin() {
    this.adminService.getMedecin("", 0, 0).subscribe(data => {
      this.personnel_med = data;
    }, err => {

    });
  }


  openActivity__(id_remb: any) {
    this.router.navigate(['rapport-med-det/' + id_remb]);
  }

  openActivity(id_remb: any) {
    //322670
    let im_chef = 322670
    //320744
    let im_daf = 320744
    //"203 131 007 842"
    let im_li = 438282
    let im_tody = 280246
    let im_sophie = 278440
    if (id_remb == this.id_agent_actuel || this.id_agent_actuel == im_chef
      || this.id_agent_actuel == im_daf || this.id_agent_actuel == im_li
      || this.id_agent_actuel == im_tody || this.id_agent_actuel == im_sophie) {
      this.router.navigate(['rapport-med-det/' + id_remb]);
    } else {
      error_message.show();
    }

  }



  onlickmodifierPers(id_med: any) {
    this.cmsService.getInfoMedbyId(id_med)
      .subscribe(data => {
        this.personnel = data;
        this.open();
      },
        err => {
          console.log(err);
        })
  }

  savePers() {
    if (this.personnel.id_pers == null) {
      this.cmsService.savePerseCMS(this.personnel)
        .subscribe(data => {
          success_message.show();
           this.getListeMed();
            this.popupProcedure.hide();
        }, err => {
          // console.log(JSON.parse(err._body).message);
        })
    } else {
      console.log("manova");
      this.cmsService.updatePerseCMS(this.personnel)
        .subscribe(data => {
          success_message.show();
           this.getListeMed();
           this.popupProcedure.hide();
        }, err => {
          // console.log(JSON.parse(err._body).message);
        })
    }

  }





  open() {
    this.popupProcedure.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: "Info Personnel",
      widthProsentage: 35,
      animation: "fadeInUp",
      confirmBtnContent: "Modifier",
      cancleBtnContent: "Fermer",
    }

    this.popupProcedure.show(this.popupProcedure.options);

  }






}
